import { render, staticRenderFns } from "./MobileFixedTop.vue?vue&type=template&id=8474173a&scoped=true&"
import script from "./MobileFixedTop.vue?vue&type=script&lang=js&"
export * from "./MobileFixedTop.vue?vue&type=script&lang=js&"
import style0 from "./MobileFixedTop.vue?vue&type=style&index=0&id=8474173a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8474173a",
  null
  
)

export default component.exports